// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"_-_-pharmacy-src-answer-writeAnswer-pollPrompt__buttonGroup--3X8oG","button":"_-_-pharmacy-src-answer-writeAnswer-pollPrompt__button--2FG3U"};